import classNames from 'classnames';

import type { VFC } from 'react';

import * as styles from './ProgressBar.module.scss';

export interface ProgressBarProps {
  // Between 0 and 1
  value?: number;
  className?: string;
}

export const ProgressBar: VFC<ProgressBarProps> = ({ value, className }) => {
  if (!value) {
    return null;
  }

  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.background}>
        <div
          className={styles.progress}
          style={{ width: `${Math.min(Math.max(0, value * 100), 100)}%` }}
        />
      </div>
    </div>
  );
};
